// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3b8_G4DQCOht6Yfe7-ZaDw_0","table":"_15BlVdjIeMC4wS8xAtiJnc_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-785e2c0d","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/router/Brokerage.vue
// module id = mnI7
// module chunks = 0